import Container from "./Container.tsx";
import ContainerHeader from "./ContainerHeader.tsx";

interface LoadingStateProps {
  message: string;
}

export default function LoadingState({ message }: LoadingStateProps) {
  return (
    <Container>
      <ContainerHeader>{message}</ContainerHeader>
    </Container>
  );
}
